import {BaseComponentWithContext} from '@mintdata/mint-kit/api/components/BaseComponentWithContext';
import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {Popover} from '@mintdata/mint-kit/impl/components/popover/Popover';
import bind from 'bind-decorator';
import {action} from 'mobx';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {
    AMenuItemRenderer,
    MenuItemRendererProps
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/menus/MainMenu';
import {MenuItem} from '@mintdata-wsp/wsp/ui/components/menus/MenuItem';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';

const styles = require('./RootMenuItemRenderer.less');
const cx = classnames.bind(styles);

@observer
export class RootMenuItemRenderer extends BaseComponentWithContext<MenuItemRendererProps>
{
    @bind
    private _onRootMenuClicked(rootMenuItem:MenuItem)
    {
        return action(()=>
        {
            const vdState = rootState.ui.visualDesigner;

            vdState.menu.isMainMenuOpen = true;
            vdState.menu.openMenuItemId = rootMenuItem.id;

            this._fireMenuClickHandler(rootMenuItem);
        });
    }

    @bind
    private _onRootMenuMouseOver(menuItem:MenuItem)
    {
        return action(()=>
                      {
                          const vdState = rootState.ui.visualDesigner;
                          vdState.menu.openMenuItemId = menuItem.id;
                      });
    }

    @bind
    private _onRootMenuPopupClosed()
    {
        this._closeMainMenu();
    }

    @bind
    private _onSubMenuClicked(subMenuItem:MenuItem)
    {
        this._fireMenuClickHandler(subMenuItem);
        this._closeMainMenu();
    }

    @action.bound
    private _closeMainMenu()
    {
        const vdState = rootState.ui.visualDesigner;
        vdState.menu.isMainMenuOpen = false;
        vdState.menu.openMenuItemId = null;
    }

    private _fireMenuClickHandler(menuItem:MenuItem)
    {
        const {handler} = this.props;

        if( handler )
            handler(menuItem);
    }

    private _renderPopover()
    {
        const {menuItem} = this.props;
        const {id} = menuItem;

        return  <Popover id={id}
                         onDismissed={this._onRootMenuPopupClosed}
                         isModal={false}>
                    <Column className={cx('dropdownColumn')}>
                        {menuItem.subMenus
                            .map((subMenu, idx:number)=>
                            {
                                const Renderer:AMenuItemRenderer = subMenu.renderer;
                                const className = idx === 0? cx('firstMenuItemInColumn') : null;

                                return <Renderer key={subMenu.id}
                                                 className={className}
                                                 menuItem={subMenu}
                                                 handler={this._onSubMenuClicked}/>
                            })
                        }
                    </Column>
                </Popover>;
    }

    public render():JSX.Element
    {
		const {popupManager} = this.context;
        const {menuItem, className} = this.props;
        const {id} = menuItem;

        const vdState = rootState.ui.visualDesigner;
        const menuState = vdState.menu;
        const isOpen =  menuState.isMainMenuOpen;
        const openMenuItemId =  menuState.openMenuItemId;
        const isThisMenuOpen = isOpen && openMenuItemId && openMenuItemId === menuItem.id;
        const isEnabled = menuItem.isEnabled;

        return (
            <Row className={cx(     'rootMenuItem',
                                    // className,
                                    {isOpen:isThisMenuOpen},
                                    {isClosed:!isThisMenuOpen},
                                    {'disabledMenuItem': !isEnabled}
                               )
                           }
                 onClick={isEnabled?this._onRootMenuClicked(menuItem):null}
                 onMouseOver={isEnabled?this._onRootMenuMouseOver(menuItem):null}
                 aRef={popupManager.position(id, SourceAnchor.LeftBottom, PopupAnchor.LeftTop)}>

                {menuItem.title}
                {isThisMenuOpen? this._renderPopover():null}

            </Row>
        );
    }
}
